// Shown in a dialog whose step changed while it was open, for example
// because another admin moved the cutover
export function StepChangedNotice() {
  return (
    <p
      role="alert"
      className="rounded-md border border-destructive px-4 py-3 text-sm text-destructive"
    >
      The cutover changed step while this dialog was open. Close it and check
      the page again.
    </p>
  );
}
